import { useEffect, useState } from "react";
import axios from "axios";

type LayananItem = {
  id: number;
  name: string;
  slug: string;
  image: string;
  created_at: string;
  updated_at: string;
};

type ApiResponse = {
  status: number;
  message: string;
  data: LayananItem[];
};

const useFetchLayananData = () => {
  const [layanan, setLayanan] = useState<LayananItem[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<ApiResponse>(
          "https://admin.macspace.id/public/api/devices"
        );
        setLayanan(response.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  return layanan;
};

export default useFetchLayananData;
